import type { SVGProps } from 'react';

/**
 * Small hand-drawn glyph set for the bottom tab bar — kept as raw SVG
 * (rather than pulling in an icon library) so the stroke weight and corner
 * treatment match the stenciled, industrial character of the rest of the UI.
 */

const baseProps: SVGProps<SVGSVGElement> = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'square',
  strokeLinejoin: 'miter',
};

export const RouteGlyph = () => (
  <svg {...baseProps} aria-hidden="true">
    <circle cx="5" cy="6" r="2" />
    <circle cx="19" cy="18" r="2" />
    <path d="M5 8v3a4 4 0 0 0 4 4h6a4 4 0 0 1 4 4" strokeDasharray="2 2.5" />
  </svg>
);

export const AdminGlyph = () => (
  <svg {...baseProps} aria-hidden="true">
    <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
    <path d="M9.5 12l1.75 1.75L14.5 10" />
  </svg>
);

export const ProfileGlyph = () => (
  <svg {...baseProps} aria-hidden="true">
    <circle cx="12" cy="8" r="3.5" />
    <path d="M5 20c0-3.9 3.13-7 7-7s7 3.1 7 7" />
  </svg>
);

export const DownloadGlyph = () => (
  <svg {...baseProps} aria-hidden="true">
    <path d="M12 3v11" />
    <path d="M7.5 10L12 14.5 16.5 10" />
    <path d="M4.5 18h15" />
  </svg>
);

export const ShareGlyph = () => (
  <svg {...baseProps} aria-hidden="true">
    <path d="M12 15V4" />
    <path d="M8 8L12 4 16 8" />
    <path d="M5 12v6.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V12" />
  </svg>
);

export const AddSquareGlyph = () => (
  <svg {...baseProps} aria-hidden="true">
    <rect height="16" rx="1" width="16" x="4" y="4" />
    <path d="M12 8.5v7" />
    <path d="M8.5 12h7" />
  </svg>
);
